import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, addLocaleData } from 'react-intl';
import moment from 'moment';

import en from 'react-intl/locale-data/en';
import he from 'react-intl/locale-data/he';
import ar from 'react-intl/locale-data/ar';

import enMessages from 'locales/en.json';
import heMessages from 'locales/he.json';
import arMessages from 'locales/ar.json';

import enMessagesUnified from 'locales/unified/en.json';
import heMessagesUnified from 'locales/unified/he.json';
import arMessagesUnified from 'locales/unified/ar.json';

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

const langMap = {
  en: { ...enMessages, ...enMessagesUnified },
  he: { ...heMessages, ...heMessagesUnified },
  ar: { ...arMessages, ...arMessagesUnified },
};

addLocaleData([
  ...en,
  ...he,
  ...ar,
]);

class IntlProviderConnected extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    locale: PropTypes.string.isRequired,
    rtl: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    children: <div>Language page</div>,
  };

  componentDidMount() {
    this.updateBodyClassname();
  }

  componentDidUpdate() {
    this.updateBodyClassname();
  }

  updateBodyClassname = () => {
    document.documentElement.setAttribute('lang', this.props.locale);
    moment.locale(this.props.locale);

    if (this.props.rtl) {
      document.body.setAttribute('dir', 'rtl');
    } else {
      document.body.setAttribute('dir', 'ltr');
    }
  };

  render() {
    const { rtl, children, locale } = this.props;
    return children ? (
      <IntlProvider
        locale={ locale }
        messages={ langMap[locale] }
      >
        <MuiPickersUtilsProvider utils={ MomentUtils } locale={ locale }>
          <div className={ rtl ? 'rtl' : 'ltr' }>
            { children }
          </div>
        </MuiPickersUtilsProvider>
      </IntlProvider>
    ) : <div>error</div>;
  }
}

export default IntlProviderConnected;
